import React from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import { useDeleteInternalUser } from 'hooks/api'

import { Stack, Typography } from '@mui/material'

import { Modal, Button } from '@repo/ui'

interface DeleteInternalUserModalProps {
  user: {
    id: string
    email: string
    first_name?: string | null
    last_name?: string | null
  }
  open: boolean
  onClose: () => void
  onDeleted?: () => void
}

export const DeleteInternalUserModal = (props: DeleteInternalUserModalProps) => {
  const { user, open, onClose, onDeleted } = props
  const { open: notification } = useSnackbar()

  const { mutate: deleteUser, isPending } = useDeleteInternalUser()

  const handleDeleteUser = () => {
    deleteUser(
      { userId: user.id },
      {
        onSuccess: () => {
          handleClose()
          onDeleted?.()
        },
        onError: (error: any) => {
          const message = getErrorMessage(error)
          notification({
            type: 'error',
            title: message,
          })
        },
      }
    )
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      title="Delete user"
      open={open}
      onClose={handleClose}
      actions={
        <>
          <Button
            disableElevation
            variant="secondary"
            onClick={() => handleClose()}
            disabled={isPending}
          >
            Cancel
          </Button>

          <Button
            disableElevation
            destructive
            onClick={() => handleDeleteUser()}
            disabled={isPending}
          >
            {isPending ? 'Deleting...' : 'Delete'}
          </Button>
        </>
      }
    >
      <Stack spacing="16px">
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
          This permanently deletes the user and removes their login. This cannot be undone.
        </Typography>
      </Stack>
    </Modal>
  )
}
